const middleware = {}

middleware['check-params'] = require('../middleware/check-params.js')
middleware['check-params'] = middleware['check-params'].default || middleware['check-params']

middleware['custom-auth'] = require('../middleware/custom-auth.js')
middleware['custom-auth'] = middleware['custom-auth'].default || middleware['custom-auth']

middleware['force-oauth-binding'] = require('../middleware/force-oauth-binding.js')
middleware['force-oauth-binding'] = middleware['force-oauth-binding'].default || middleware['force-oauth-binding']

middleware['metrika'] = require('../middleware/metrika.js')
middleware['metrika'] = middleware['metrika'].default || middleware['metrika']

middleware['roles'] = require('../middleware/roles.js')
middleware['roles'] = middleware['roles'].default || middleware['roles']

middleware['special-project'] = require('../middleware/special-project.js')
middleware['special-project'] = middleware['special-project'].default || middleware['special-project']

export default middleware
